import React, { Component } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { card } from '../CSS/card'
import { font } from '../CSS/font'
import { tabs } from '../CSS/tab'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActionArea from '@material-ui/core/CardActionArea'
import {Line} from 'react-chartjs-2';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import moment from 'moment'

import Badge from '@material-ui/core/Badge';
import { Divider } from '@material-ui/core';

const styles = {...font,...card,...tabs}

//
//        data:[{id: int, label: string, badge: int, content: React DOM element eg. (<div/>) },
//              {id: int, label: string, badge: int, content: React DOM element}]

class CustomizedTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            value: 0
        }
    }

    componentWillUpdate(prevProps) {
        if (this.state.data !== prevProps.data) {
            this.setState( {
                data: this.props.data,
                value: 0
            } )
        }
    }

    handleTabChange = (event, value) => {
         this.setState({ value });
    };



    render() {
        const { classes } = this.props;






        return (
            <div className={classes.div}>
                <Tabs
                    classes={{indicator:classes.tab_indicator}}
                    value={this.state.value}
                    textColor="primary"
                    onChange={this.handleTabChange}
                >
                {
                    this.state.data.map((dataitem)=>{
                        if (dataitem.badge != null){
                            return(
                                <Tab className={[classes.tab_label, classes.tab_element]} label={                        
                                    <Badge color="secondary" className={classes.padding} badgeContent={dataitem.badge} >
                                        {dataitem.label}
                                    </Badge>} 
                                />
                            )
                        }else{
                            return(
                                <Tab className={[classes.tab_label, classes.tab_element]} label={dataitem.label}/>
                            )
                        }
                    })
                }
                </Tabs>
                <Divider />
                    {this.state.data.map((dataitem)=>{
                        return(
                            this.state.value == dataitem.id ? dataitem.content : null
                        )
                    })}
                <Divider />
            </div>
        )
    }
}
export default withStyles(styles)(CustomizedTab);






// WEBPACK FOOTER //
// ./src/components/CSSComponent/tabs.js